module.exports = __webpack_public_path__ + "0bcbfdf147f5185f4a3a9f9a9ac30def.jpg";